/**
 * Weedfetti is a component primarily rendered using a context. The `useWeedfetti`
 * hook provides a function called `launchWeedfetti`, which can be called anywhere
 * to launch a cascade of weed-shaped confetti across the page.
 *
 * This context requires the `WeedfettiFrame` to be rendered as high up the React
 * tree as possible. In next.js applications, this is likely in the _app.js file,
 * but could also be in a shared layout component, if one exists. This "frame"
 * has no properties except for `children`.
 *
 * A minimal implementation would appear as shown below.
 *
 * In _app.js:
 *
 *   class MyApp extends App {
 *     render() {
 *       const { Component, pageProps } = this.props;
 *
 *       return (
 *         <WeedfettiFrame>
 *           <Component {...pageProps} />
 *         </WeedfettiFrame>
 *       )
 *     }
 *   }
 *
 * Somewhere else inside of the application:
 *
 *   function ConfettiButton() {
 *     const { launchWeedfetti } = useWeedfetti();
 *
 *     return (
 *       <button onClick={() => launchWeedfetti({ colors: ["#ff4", "#ae3"] })}>
 *         Launch
 *       </button>
 *     );
 *   }
 *
 */
export { useWeedfetti } from "./WeedfettiContext";
export * from "./WeedfettiFrame";
